import { Card, Row, Col, Badge } from 'react-bootstrap';
import { FaFileAlt, FaCalculator } from 'react-icons/fa';

const TransactionSummary = ({ 
  order, 
  quantity, 
  price,
  hasPreuve = false 
}) => {
  if (!order) return null;

  const calculatedAmount = quantity ? (parseFloat(quantity) * parseFloat(price)) : 0;

  return (
    <Card className="border-0 bg-light mb-4">
      <Card.Body>
        <h6 className="d-flex align-items-center mb-3">
          <FaCalculator className="text-primary me-2" />
          Récapitulatif de la transaction
        </h6>
        
        <Row className="g-3">
          <Col sm={6}>
            <div className="d-flex justify-content-between align-items-center">
              <span className="text-muted">Ordre:</span>
              <Badge bg="outline-primary" text="dark">
                #{order.id}
              </Badge>
            </div>
          </Col>
          
          <Col sm={6}>
            <div className="d-flex justify-content-between align-items-center">
              <span className="text-muted">Titre:</span>
              <span className="fw-medium text-truncate" title={order.securityName}>
                {order.securityName}
              </span>
            </div>
          </Col>
          
          <Col sm={6}>
            <div className="d-flex justify-content-between">
              <span className="text-muted">Quantité:</span>
              <span className="fw-semibold">{quantity || 0}</span>
            </div>
          </Col>
          
          <Col sm={6}>
            <div className="d-flex justify-content-between">
              <span className="text-muted">Prix unitaire:</span>
              <span className="fw-semibold">{parseFloat(price || 0).toLocaleString()} Fcfa</span>
            </div>
          </Col>
          
          <Col sm={6}>
            <div className="d-flex justify-content-between">
              <span className="text-muted">Montant total:</span>
              <span className="fw-bold text-success">
                {calculatedAmount.toLocaleString()} Fcfa
              </span>
            </div>
          </Col>
          
          <Col sm={6}>
            <div className="d-flex justify-content-between align-items-center">
              <span className="text-muted">Preuve:</span>
              {hasPreuve ? (
                <Badge bg="success" className="d-flex align-items-center">
                  <FaFileAlt className="me-1" size={12} />
                  Ajoutée
                </Badge>
              ) : (
                <Badge bg="danger" text="white" className="d-flex align-items-center">
                  Obligatoire 
                </Badge>
              )}
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default TransactionSummary;